import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../../../basics/Icon/Icon.js';
import Button$1 from '../../../../basics/Button/Button.js';
import Typography$1 from '../../../../basics/Typography/Typography.js';
import StyledControls from './Controls.style.js';

const Controls = ({
  handleNext,
  handlePrevious,
  handleOverview,
  handleChange,
  handleClose,
  currentIndex,
  currentCaption,
  isOverview,
  numberOfBullets
}) => /*#__PURE__*/React$1.createElement(StyledControls, null, !isOverview && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, /*#__PURE__*/React$1.createElement("button", {
  onClick: () => handleNext(),
  className: "controls__next"
}, "Next ", /*#__PURE__*/React$1.createElement(Icon$1, {
  icon: "rightArrow",
  alignment: "right"
})), /*#__PURE__*/React$1.createElement("button", {
  onClick: () => handlePrevious(),
  className: "controls__prev"
}, /*#__PURE__*/React$1.createElement(Icon$1, {
  icon: "leftArrow",
  alignment: "left"
}), " Prev")), /*#__PURE__*/React$1.createElement("div", {
  className: "controls__content"
}, /*#__PURE__*/React$1.createElement("button", {
  type: "button",
  onClick: handleOverview,
  className: "controls__close",
  "aria-label": isOverview ? 'Close 0verview' : 'Open Overview'
}, isOverview ? /*#__PURE__*/React$1.createElement(Icon$1, {
  icon: "slider"
}) : /*#__PURE__*/React$1.createElement(Icon$1, {
  icon: "overview"
})), !isOverview && /*#__PURE__*/React$1.createElement(React$1.Fragment, null, currentCaption && /*#__PURE__*/React$1.createElement(Typography$1, {
  className: "controls__caption",
  variant: "small"
}, currentCaption), /*#__PURE__*/React$1.createElement("div", {
  className: "controls__bullets"
}, Array.from(Array(numberOfBullets).keys()).map(item => /*#__PURE__*/React$1.createElement("button", {
  key: item,
  type: "button",
  onClick: () => handleChange(item),
  "aria-label": `Go to slide ${item + 1}`
}, /*#__PURE__*/React$1.createElement("span", {
  className: currentIndex === item ? 'is-active' : ''
})))))), /*#__PURE__*/React$1.createElement("div", {
  className: "controls__header"
}, /*#__PURE__*/React$1.createElement(Button$1, {
  onClick: handleClose,
  icon: "cross",
  variant: "secondary",
  className: "controls__close"
}, "Close")));

Controls.propTypes = {
  handleNext: PropTypes$1.func.isRequired,
  handlePrevious: PropTypes$1.func.isRequired,
  handleOverview: PropTypes$1.func.isRequired,
  handleClose: PropTypes$1.func.isRequired,
  handleChange: PropTypes$1.func.isRequired,
  numberOfBullets: PropTypes$1.number.isRequired,
  currentIndex: PropTypes$1.number.isRequired,
  isOverview: PropTypes$1.bool.isRequired,
  currentCaption: PropTypes$1.string
};
Controls.defaultProps = {
  currentCaption: null
};

export default Controls;
